import React from 'react';
import { Package, Edit, Plus, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const stockBadgeColor = (quantity) => {
  if (quantity === 0) return 'bg-red-500';
  if (quantity <= 2) return 'bg-yellow-500';
  return 'bg-green-500';
};

export const ProductsTab = ({ products, onEditProduct, onNewProduct, onDeleteProduct }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-white flex items-center gap-2">
        <Package className="w-5 h-5" />
        Product Management
      </CardTitle>
      <Button
        onClick={onNewProduct}
        className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
        data-testid="new-product-btn"
      >
        <Plus className="w-4 h-4 mr-2" />
        New Product
      </Button>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-purple-900/50 rounded-lg p-4 border border-purple-700"
          >
            <div className="flex items-start gap-4">
              <img
                src={product.image}
                alt={product.name}
                className="w-24 h-24 object-cover rounded"
              />
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-semibold truncate">{product.name}</h3>
                <p className="text-purple-300 text-sm">{product.category}</p>
                <p className="text-yellow-400 font-bold text-lg">
                  ${product.basePrice.toFixed(2)}
                </p>
                <div className="flex flex-wrap gap-2 mt-2">
                  {product.sizes.map((size) => (
                    <Badge
                      key={`product-${product.id}-${size.size}`}
                      className={`text-xs ${stockBadgeColor(size.quantity)}`}
                    >
                      {size.size}: {size.quantity} @ ${size.price.toFixed(2)}
                    </Badge>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <Button
                  onClick={() => onEditProduct(product)}
                  className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
                  data-testid={`edit-product-${product.id}`}
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Edit
                </Button>
                <Button
                  onClick={() => onDeleteProduct(product)}
                  variant="destructive"
                  size="sm"
                  data-testid={`delete-product-${product.id}`}
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Delete
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
